// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS do showpassword */
.password_input {
  position: relative;
  margin-bottom: 16px;
}

.eye-icon {
  position: absolute;
  top: 50%;
  right: 14px;
  color: var(--ui-muted);
  opacity: .9;
  transform: translateY(-50%);
  cursor: pointer;
}

/* Card do topo com avatar + resumo do usuário */
.profile-hero {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.profile-avatar {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--fundo2);
  color: var(--azul2);
  font-size: 26px;
  font-weight: 700;
}

.profile-heading h2 {
  margin: 0 0 4px;
}

.profile-email {
  color: var(--ui-muted);
  margin-bottom: 8px;
}

.profile-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.profile-badge {
  display: inline-block;
}

/* Grid de dados pessoais/funcionais */
.profile-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.profile-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 0;
  border-bottom: 1px solid var(--ui-border);
}

.profile-info-item span {
  font-size: 12px;
  color: var(--ui-muted);
  text-transform: uppercase;
  letter-spacing: .4px;
}

.profile-info-item strong {
  color: var(--ui-text);
  font-weight: 600;
}

/* Card de alterar senha */
.password-card {
  max-width: 460px;
  margin-top: 20px;
}

.password-steps {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 24px;
}

.password-step {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.password-step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  background: var(--ui-input-bg);
  color: var(--ui-muted);
  border: 1px solid var(--ui-border);
}

.password-step-label {
  font-size: 11px;
  color: var(--ui-muted);
}

.password-step.active .password-step-circle {
  background: var(--ui-primary);
  border-color: var(--ui-primary);
  color: #fff;
}

.password-step.active .password-step-label {
  color: var(--ui-primary);
  font-weight: 600;
}

.password-step.done .password-step-circle {
  background: var(--verde2);
  border-color: var(--verde);
  color: var(--verde);
}

.password-step-content {
  display: flex;
  flex-direction: column;
}

.password-step-content > p {
  margin-bottom: 16px;
}

.password-step-content > input {
  margin-bottom: 16px;
}

.password-step-content > button {
  align-self: flex-start;
}

.password-checklist {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.password-checklist li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--ui-muted);
}

.password-checklist li.valid {
  color: var(--verde);
}

.password-checklist-icon {
  width: 16px;
  text-align: center;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Usuario/usuario.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* CSS do showpassword */\n.password_input {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.eye-icon {\n  position: absolute;\n  top: 50%;\n  right: 14px;\n  color: var(--ui-muted);\n  opacity: .9;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n/* Card do topo com avatar + resumo do usuário */\n.profile-hero {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.profile-avatar {\n  flex-shrink: 0;\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--fundo2);\n  color: var(--azul2);\n  font-size: 26px;\n  font-weight: 700;\n}\n\n.profile-heading h2 {\n  margin: 0 0 4px;\n}\n\n.profile-email {\n  color: var(--ui-muted);\n  margin-bottom: 8px;\n}\n\n.profile-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.profile-badge {\n  display: inline-block;\n}\n\n/* Grid de dados pessoais/funcionais */\n.profile-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.profile-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--ui-border);\n}\n\n.profile-info-item span {\n  font-size: 12px;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n  letter-spacing: .4px;\n}\n\n.profile-info-item strong {\n  color: var(--ui-text);\n  font-weight: 600;\n}\n\n/* Card de alterar senha */\n.password-card {\n  max-width: 460px;\n  margin-top: 20px;\n}\n\n.password-steps {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.password-step {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n}\n\n.password-step-circle {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  background: var(--ui-input-bg);\n  color: var(--ui-muted);\n  border: 1px solid var(--ui-border);\n}\n\n.password-step-label {\n  font-size: 11px;\n  color: var(--ui-muted);\n}\n\n.password-step.active .password-step-circle {\n  background: var(--ui-primary);\n  border-color: var(--ui-primary);\n  color: #fff;\n}\n\n.password-step.active .password-step-label {\n  color: var(--ui-primary);\n  font-weight: 600;\n}\n\n.password-step.done .password-step-circle {\n  background: var(--verde2);\n  border-color: var(--verde);\n  color: var(--verde);\n}\n\n.password-step-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.password-step-content > p {\n  margin-bottom: 16px;\n}\n\n.password-step-content > input {\n  margin-bottom: 16px;\n}\n\n.password-step-content > button {\n  align-self: flex-start;\n}\n\n.password-checklist {\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.password-checklist li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--ui-muted);\n}\n\n.password-checklist li.valid {\n  color: var(--verde);\n}\n\n.password-checklist-icon {\n  width: 16px;\n  text-align: center;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
